import useCookies from '~/composables/useCookies'

export default () => {
  const cookies = useCookies()

  const showFlashNoticeMessage = (message: string) => {
    cookies.set('flashNoticeMessage', message)
  }

  const showFlashWarningMessage = (message: string) => {
    cookies.set('flashWarningMessage', message)
  }

  const showFlashAlertMessage = (message: string) => {
    cookies.set('flashAlertMessage', message)
  }

  return {
    showFlashNoticeMessage,
    showFlashWarningMessage,
    showFlashAlertMessage
  }
}
